import ServiciosGenericos from './ServiciosGenericos';
import {solicitar_datos} from './Api';

export default class ServiciosGenericosDeAPI extends ServiciosGenericos {
    constructor(nombreDeModulo){
        super(nombreDeModulo, solicitar_datos);
    }
}